import {AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {OfwcaService} from "../../../shared/services/ofwca.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {
  ChangeRegionalDialogData
} from "../ofwca-change-account-number-dialog/ofwca-change-account-number-dialog.component";
import {of, ReplaySubject} from "rxjs";
import {Ofwca} from "../../../shared/interface/ofwca";
import {validIban} from "../../../shared/validator/iban-validator";
import {HttpErrorResponse} from "@angular/common/http";
import {delay, takeUntil} from "rxjs/operators";
import {Partner} from "../../../shared/interface/partner";

@Component({
  selector: 'app-ofwca-change-hiperio-data',
  templateUrl: './ofwca-change-hiperio-data.component.html',
  styleUrls: ['./ofwca-change-hiperio-data.component.scss']
})
export class OfwcaChangeHiperioDataComponent implements OnInit {

  changeHiperioDataForm: FormGroup;
  ofwcaObject: Ofwca;
  hiperioBlockedAccountControl: FormControl;
  processingRequest = false;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<OfwcaChangeHiperioDataComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeRegionalDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private ofwcaService: OfwcaService,
    private snack: MatSnackBar,
  ) {
    this.ofwcaObject = data.ofwcaObject;
    this.changeHiperioDataForm = fb.group({
      hiperioBlockedAccount: this.hiperioBlockedAccountControl = fb.control(this.ofwcaObject.hiperioBlockedAccount, []),
    });
  }

  ngOnInit(): void {
  }



  sendForm(): void {
    this.processingRequest = true;

    this.ofwcaService.changeHiperioData(this.changeHiperioDataForm.value, this.ofwcaObject.uuid)
      .subscribe(() => {
        this.snack.open('Pomyślnie zaktualizowano obiekt', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas aktualizacji obiektu partnera wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });


      })
    ;
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

}
